import { IsNotEmpty, IsIn } from "class-validator";

import { Constants } from "@eagerdog/constants";

import { IWaterDogScore } from "./water-dog-score.interface";

export class WaterDogScoreDto implements IWaterDogScore {
  //
  @IsNotEmpty()
  @IsIn(Object.values(Constants.score_result_type))
  result_type: string;

  @IsNotEmpty()
  time: number;
}
